import { validateEmail, validateForm } from './formValidation';

/**
 * 认证相关的表单验证工具
 */

// 登录表单验证 - 不需要密码复杂度验证
export const validateLoginForm = (data: { email: string; password: string; terms: boolean }) => {
  const errors: Record<string, string> = {};

  // 验证邮箱
  if (!data.email) {
    errors.email = 'Please enter email address';
  } else if (!validateEmail(data.email)) {
    errors.email = 'Please enter a valid email address';
  }

  // 验证密码 - 登录时只需要非空验证
  if (!data.password) {
    errors.password = 'Please enter password';
  }

  // 验证服务条款
  if (!data.terms) {
    errors.terms = 'Please agree to Terms of Service and Privacy Policy';
  }

  return errors;
};

// 注册表单验证
export const validateRegisterForm = (data: {
  email: string;
  verificationCode: string;
  password: string;
  terms: boolean;
}) => {
  return validateForm(data);
};

// 忘记密码表单验证
export const validateForgotPasswordForm = (data: {
  email: string;
  verificationCode: string;
  password: string;
  confirmPassword: string;
}) => {
  const errors = validateForm(data);

  // 独立检查密码匹配，不受密码格式校验影响
  // 这样可以同时显示密码格式错误和密码不匹配错误
  if (data.password && data.confirmPassword && data.password !== data.confirmPassword) {
    errors.confirmPassword = 'Passwords do not match';
  }

  return errors;
};

// 验证邮箱是否可以发送验证码
export const validateEmailForCode = (email: string): { isValid: boolean; error?: string } => {
  if (!email) {
    return { isValid: false, error: 'Please enter email address' };
  }
  if (!validateEmail(email)) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }
  return { isValid: true };
};

// 实时验证密码匹配
export const validatePasswordMatch = (password: string, confirmPassword: string): string => {
  if (!confirmPassword) {
    return '';
  }
  if (password !== confirmPassword) {
    return 'Passwords do not match';
  }
  return '';
};